<template>
  <div class="data-status">
    <i class="icon" :class="currentStatus.icon"></i>
    <p class="text">{{ currentStatus.text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: 'loading',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusMap: {
        loading: {
          text: '别着急数据正在加载中哦~',
          icon: 'is-loading',
        },
        empty: {
          text: '您暂时还没有数据呢~',
          icon: 'is-empty',
        },
      },
    };
  },
  computed: {
    currentStatus() {
      return this.statusMap[this.status];
    },
  },
};
</script>

<style lang="less" scoped>
.data-status {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: rgba(255, 255, 255, 0.8);
  .icon {
    width: 160px;
    height: 160px;
    margin-bottom: 30px;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .text {
    color: #8c8c8c;
  }
}
.is-loading {
  background-image: url(~@/assets/images/data_loading@2x.png);
}
.is-empty {
  background-image: url(~@/assets/images/data_empty@2x.png);
}
</style>
